import { NotificationManager } from "react-notifications";

/**
 * @return {Object}
 */
function Validator(job, notify) {
  const required = {department: 'Department'};

  const requiredNested = {
    vehicle: "registration",
    customer: "id"
  };

  let missing = [];
  let missingPartSuppliers = [];
  let invalidWorkTypes = [];

  for (let field in required) {
    if (!job[field] || job[field].length === 0) {
      missing.push(required[field]);
    }
  }

  for (let field in requiredNested) {
    if (
      !job[field] ||
      !job[field][requiredNested[field]] ||
      job[field][requiredNested[field]].length === 0
    ) {
      missing.push(field);
    }
  }

  job.estimated_work_items.forEach(item => {
    item.parts.forEach(part => {
      if (!part.supplier || !part.supplier.id) {
        missingPartSuppliers.push(part.name || "Unnamed Part");
      }
    });
  });

  job.estimated_work_items.forEach((item, index) => {
    if(!item.work_type){
      invalidWorkTypes.push(item.description || ("Work Item "+(index+1)))
    }
  });

  if (notify) {
    missing.forEach(name => {
      NotificationManager.warning(
        `You must specify a ${name}`,
        "Missing Data",
        10000
      );
    });

    missingPartSuppliers.forEach(name => {
      NotificationManager.warning(
        `Part ${name} is missing a supplier!`,
        "Missing Data",
        10000
      );
    });

    invalidWorkTypes.forEach(name => {
      NotificationManager.warning(
          `You must specify a work type for ${name}`,
          "Missing Work Type",
          10000
      );
    });
  }


  return {
    missingPartSuppliers: missingPartSuppliers,
    missing: missing,
    invalidWorkTypes: invalidWorkTypes,
    result: missing.length === 0 && missingPartSuppliers.length === 0 && invalidWorkTypes.length === 0
  };
}

export default Validator;
